import request from '@/utils/request.js'

/**
 *  APP-检查是否开设工作室-是否加入工作室
 * @param params
 * @returns {AxiosPromise}
 */
export function checkJoinWorkstation(params) {
    return request({
        url: 'workstationService/api/app/workstation/checkJoinWorkstation',
        method: 'post',
        data: params
    })
}

/**
 *  APP-详情-工作室
 * @param params
 * @returns {AxiosPromise}
 */
export function getWorkstationForDetail(params) {
    return request({
        url: 'workstationService/api/app/workstation/getWorkstationForDetail',
        method: 'post',
        data: params
    })
}


/**
 * App-保存工作室
 * @param params
 * @returns {AxiosPromise}
 */
export function saveStudio(params) {
    return request({
        url: 'workstationService/api/app/workstation/save',
        method: 'post',
        data: params
    })
}

/**
 * APP-修改工作室
 * @param params
 * @returns {AxiosPromise}
 */
export function updateWorkstation(params) {
    return request({
        url: 'workstationService/api/app/workstation/updateWorkstation',
        method: 'post',
        data: params
    })
}

/**
 * APP-工作室列表
 * @param params
 * @returns {AxiosPromise}
 *

 */
export function studioList(params) {
    return request({
        closeLoading: true,
        url: 'workstationService/api/app/workstation/list',
        method: 'post',
        data: params
    })
}

/**
 * APP-新建工作室按钮用
 * @param params
 * @returns {AxiosPromise}
 *

 */
export function checkWorkstationInfo(params) {
    return request({
        url: 'workstationService/api/app/workstation/checkWorkstationInfo',
        method: 'post',
        data: params
    })
}

/**
 * APP-申请离开工作室-申请
 * @param params
 * @returns {AxiosPromise}
 *
 */
export function leaveStudio(params) {
    return request({
        closeInterceptors: true,
        url: 'workstationService/api/app/workstation/member/approve/leave',
        method: 'post',
        data: params
    })
}

/**
 * APP-申请加入工作室
 * @param params
 * @returns {AxiosPromise}
 *
 */
export function joinStudio(params) {
    return request({
        url: 'workstationService/api/app/workstation/member/approve/save',
        method: 'post',
        data: params
    })
}

/**
 * APP-申请加入工作室
 * @param params
 * @returns {AxiosPromise}
 *
 */
export function checkMemberInfo(params) {
    return request({
        url: 'workstationService/api/app/workstation/member/approve/checkMemberInfo',
        method: 'post',
        data: params
    })
}




